import React, { createContext, ReactNode, useContext, useMemo } from 'react'
import { BackendClient } from '../../backend/client'

const BackendClientContext = createContext<BackendClient | null>(null)

interface BackendClientProviderProps {
  children: ReactNode
  baseUrl: string
}

export const BackendClientProvider = ({ children, baseUrl }: BackendClientProviderProps) => {
  const client = useMemo(() => {
    return new BackendClient(baseUrl)
  }, [baseUrl])

  return React.createElement(BackendClientContext.Provider, { value: client }, children)
}

export const useBackendClient = (): BackendClient => {
  const backendClient = useContext(BackendClientContext)
  if (!backendClient) {
    throw new Error('useBackendClient must be used within a BackendClientProvider')
  }
  return backendClient
}
